import { render, staticRenderFns } from "./CustomBlock.vue?vue&type=template&id=359dd672&scoped=true"
import script from "./CustomBlock.vue?vue&type=script&lang=ts"
export * from "./CustomBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359dd672",
  null
  
)

export default component.exports